var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTravel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M849.92 914.176c33.93 0 61.44-27.51 61.44-61.44V378.132c0-33.93-27.51-61.44-61.44-61.44H174.08c-33.93 0-61.44 27.51-61.44 61.44v474.604c0 33.93 27.51 61.44 61.44 61.44h675.84zm0 40.96H174.08c-56.551 0-102.4-45.849-102.4-102.4V378.132c0-56.551 45.849-102.4 102.4-102.4h675.84c56.551 0 102.4 45.849 102.4 102.4v474.604c0 56.551-45.849 102.4-102.4 102.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M234.752 297.444v622.551c0 11.311 9.169 20.48 20.48 20.48s20.48-9.169 20.48-20.48V297.444c0-11.311-9.169-20.48-20.48-20.48s-20.48 9.169-20.48 20.48zm513.024 9.918v622.551c0 11.311 9.169 20.48 20.48 20.48s20.48-9.169 20.48-20.48V307.362c0-11.311-9.169-20.48-20.48-20.48s-20.48 9.169-20.48 20.48zM389.12 286.72V163.84c0-33.93 27.51-61.44 61.44-61.44h143.36c33.93 0 61.44 27.51 61.44 61.44v122.88c0 11.311 9.169 20.48 20.48 20.48s20.48-9.169 20.48-20.48V163.84c0-56.551-45.849-102.4-102.4-102.4H450.56c-56.551 0-102.4 45.849-102.4 102.4v122.88c0 11.311 9.169 20.48 20.48 20.48s20.48-9.169 20.48-20.48z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravel);
export default __webpack_public_path__ + "static/media/travel.53716286bb6d273e81dc0bac92325727.svg";
export { ForwardRef as ReactComponent };